import contract from '@mailobj-browser/front/js/contracts/contract.js'
import array from '@mailobj-browser/front/js/utils/array.js'
import display from './display/display.js'

export default contract({
    display: array([
        display
    ]),
})